var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table-detail bg-hard-white"},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(column){return _c('th',[_vm._v(_vm._s(column))])}),0)]),_vm._v(" "),_c('tbody',[_c('tr',_vm._l((_vm.data),function(data,index){return _c('td',{key:index},[_vm._v("\n                "+_vm._s(data)+"\n            ")])}),0)])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e3189e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TableDetail.vue
// module id = ubnk
// module chunks = 44